module.exports = __webpack_public_path__ + "img/icon-upload-white.39b395af.svg";